module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/universes/haircut-44cdecc03359351abe92cc4069a81644.png";